module.exports = __webpack_public_path__ + "img/gift.89958faa.svg";